import axios from 'axios';
import {
    SET_VARIANT_MODAL_OPENED, SET_SELECTED_PRODUCT, SET_PROMO_PRODUCT_FOR_CATEGORY_MODAL_OPENED
} from './types';
import { API_URL, DEFAULT_PRODUCT_IMAGE, BILL_WANTED_EXPIRE_TIME_MINUTES } from '../../constants'
import { openScanModal, setCurrOpenedModal, closeScanModal, setOrderModalState } from './../../qr-scan/actions/scan.actions';
// import _ from 'lodash';
import Utils from '../../utils/Utils';
import Auth from '../../utils/Auth';
import history from './../../utils/history';
// import { isEqual, sortBy, difference } from 'lodash';
import { getLocalCart, changeSelectedCartTab, addToCart } from './../../products/actions/products.action';
import Cookies from 'universal-cookie';
import { isFromLinkTab, cartStorage } from '../../utils/fromLinkMode';

const cookies = new Cookies();
const TABL_CART_KEY = 'tabl_cart';

// from_link таб: количката е отделна (виж utils/fromLinkMode.js), значи и id-то ѝ.
export const getCartIdLocal = () => {
    let cart = isFromLinkTab() ? cartStorage().getItem(TABL_CART_KEY) : cookies.get(TABL_CART_KEY);
    if (cart) {
        return cart;
    }
    return null;
}

export const setCartIdLocal = (id) => {
    if (isFromLinkTab()) {
        cartStorage().setItem(TABL_CART_KEY, id);
        return;
    }
    let config = { path: "/" };
    if (process.env.NODE_ENV === 'production') {
        config.secure = true;
    }
    cookies.set(TABL_CART_KEY, id, config);
}

export const removeCartIdLocal = () => {
    if (isFromLinkTab()) {
        cartStorage().removeItem(TABL_CART_KEY);
        return;
    }
    cookies.remove(TABL_CART_KEY, { path: '/' });
}

export const updateRemoteCart = () => dispatch => {
    // console.log("REMOTE ")

    let productsArrToSend = [];
    Object.values(getLocalCart()).map(t =>
        productsArrToSend = productsArrToSend.concat(t)
    );
    axios
        .post(API_URL + 'cart', {
            cartId: getCartIdLocal(),
            products: productsArrToSend,
        }) // Timeout 35 sec
        .then(res => {
            // console.log("RES " , res)

            if (res.data.cartId) {
                setCartIdLocal(res.data.cartId);
            }

        }).catch(error => {

        });
}

export const addProdToCart = (product_id, product_variant_id, product, productIngredients, forceNewLine = false) => dispatch => {
    // Block ordering when product is out of stock or the chosen variant has run out.
    // Covers the path from variant modals that call addProdToCart directly.
    if (product && (product.in_stock === false || product.in_stock == 0)) {
        return;
    }
    if (product_variant_id && product && product.product_variants) {
        const chosenVariant = product.product_variants.find(v => v.id == product_variant_id);
        if (chosenVariant && chosenVariant.stock_quantity !== null && chosenVariant.stock_quantity !== undefined && parseInt(chosenVariant.stock_quantity, 10) <= 0) {
            return;
        }
    }

    const requiredProductIngridients = product.product_ingredients.filter(pi => pi.type == 'required' && productIngredients[pi.ingredientId] && productIngredients[pi.ingredientId].active == true);

    // console.log("CART: ADD PROD TO CART")

    let defautRequiredProductIngridient = 0;
    if (requiredProductIngridients && requiredProductIngridients[0] && requiredProductIngridients[0].ingredientId) {
        defautRequiredProductIngridient = requiredProductIngridients[0].ingredientId;
    }

    const requiredProductIngridients2 = product.product_ingredients.filter(pi => pi.type == 'required2' && productIngredients[pi.ingredientId] && productIngredients[pi.ingredientId].active == true);
    let defautRequiredProductIngridient2 = 0;
    if (requiredProductIngridients2 && requiredProductIngridients2[0] && requiredProductIngridients2[0].ingredientId) {
        defautRequiredProductIngridient2 = requiredProductIngridients2[0].ingredientId;
    }

    const selectedIngredients = {
        required: defautRequiredProductIngridient,
        required2: defautRequiredProductIngridient2,
        addable: [],
        removable: [],
        // Задължителните конфигурируеми групи получават първата си опция - тук няма
        // къде да се избира, точно както при required/required2 по-горе.
        groups: Utils.getDefaultGroupSelections(product.id),
    }

    // this.showAddedProductTooltip(product_id, product_variant_id, product, selectedIngredients);
    // this.props.changeSelectedCartTab(0); // select default tab "Cart"
    // this.props.addToCart(product_id, product_variant_id, product, selectedIngredients);

    dispatch(changeSelectedCartTab(0));
    let addedUuid = dispatch(addToCart(product_id, product_variant_id, product, selectedIngredients, undefined, forceNewLine));
    dispatch(setVariantModalOpened(false));

    dispatch(setPromoProductForCategoryModalOpened(false));

    return addedUuid;
};

export const addToCartBtnClicked = (currProduct, productVariantId, settings, forceNewLine = false) => dispatch => {
    // Block ordering when product is marked as out of stock. The menu may still render it
    // (depending on out_of_stock_behavior), but ordering must be disabled.
    if (currProduct && (currProduct.in_stock === false || currProduct.in_stock == 0)) {
        return;
    }

    // Also block when the specific variant being added has stock_quantity <= 0 (tracked).
    if (productVariantId && currProduct && currProduct.product_variants) {
        const chosenVariant = currProduct.product_variants.find(v => v.id == productVariantId);
        if (chosenVariant && chosenVariant.stock_quantity !== null && chosenVariant.stock_quantity !== undefined && parseInt(chosenVariant.stock_quantity, 10) <= 0) {
            return;
        }
    }

    if (settings && settings.variant_modal_with_comment && settings.variant_modal_with_comment.value == 1) {
        // this.setState({ variantModalOpen: true, selectedProduct: currProduct, variantModalWithComment: true })
        dispatch(setVariantModalOpened(true));
        dispatch(setSelectedProduct(currProduct));
        debugger;

    } else {
        if (currProduct.product_variants) {
            if (currProduct.product_variants.length === 1 || productVariantId > 0) {
                // this.addProdToCart(currProduct.id, productVariantId ? productVariantId : currProduct.product_variants[0].id, currProduct)
                return dispatch(addProdToCart(currProduct.id, productVariantId ? productVariantId : currProduct.product_variants[0].id, currProduct, undefined, forceNewLine));
            } else {
                // Open variant modal
                dispatch(setVariantModalOpened(true));
                dispatch(setSelectedProduct(currProduct));

                // this.setState({ variantModalOpen: true, selectedProduct: currProduct })
            }
        }
    }

}

export const setVariantModalOpened = (opened) => dispatch => {
    dispatch({
        type: SET_VARIANT_MODAL_OPENED,
        payload: opened
    })
}

export const setSelectedProduct = (product) => dispatch => {
    dispatch({
        type: SET_SELECTED_PRODUCT,
        payload: product
    })
}

export const setPromoProductForCategoryModalOpened = (opened) => dispatch => {
    dispatch({
        type: SET_PROMO_PRODUCT_FOR_CATEGORY_MODAL_OPENED,
        payload: opened
    })
}